import axios from "@/plugins/axios/configApi";
import axiosV1 from "@/plugins/axios/configV1";

export default {
    async exportExcel(params) {
        return axios.get(`rewards/export/users`, { params });
    },
    async syncRewardStatus(id) {
        return axiosV1.get(`rewards/sync/user/redemption/${id}`);
    },
    async getRewards(params) {
        return axios.get(`rewards/get-redemptions`, { params });
        // return axiosV1.get(`promos`, { params });
        // Dumy Data
        // console.table(params);
        // await new Promise((resolve) => setTimeout(resolve, 1000));
        // return Promise.resolve({
        //     data: {
        //         // data: [
        //         //     {
        //         //         id: 1,
        //         //         customer_name: "Mary Delacruz",
        //         //         points_claimed: 1000,
        //         //         date_of_redemption: "Nov 09, 2022, 10:00 PM",
        //         //         category: "Food",
        //         //         egift: "Jollibee PHP 200 eGift",
        //         //         status: 3,
        //         //         send_option: "SMS",
        //         //     },
        //         //     {
        //         //         id: 1,
        //         //         customer_name: "Juan Dela Cruz",
        //         //         points_claimed: 1000,
        //         //         date_of_redemption: "Nov 16, 2022, 10:00 PM",
        //         //         category: "Apparel",
        //         //         egift: "Jollibee PHP 200 eGift",
        //         //         status: 1,
        //         //         send_option: "SMS",
        //         //     },
        //         //     {
        //         //         id: 1,
        //         //         customer_name: "Mary Delacruz",
        //         //         points_claimed: 1000,
        //         //         date_of_redemption: "Dec 20, 2022, 10:00 PM",
        //         //         category: "Food",
        //         //         egift: "Jollibee PHP 200 eGift",
        //         //         status: 2,
        //         //         send_option: "Email",
        //         //     },
        //         // ],
        //         // data: [
        //         //     {
        //         //         id: 34,
        //         //         user_id: 183,
        //         //         merchant_id: 6312,
        //         //         denomination_id: 7044,
        //         //         quantity: null,
        //         //         price: 100,
        //         //         customer_name: "Yves Tatad",
        //         //         order_id: 35249094,
        //         //         urls: '["https:\\/\\/gft.ph\\/sM4scAv1Zj"]',
        //         //         giftaway_json: {
        //         //             status_code: 100,
        //         //             status: "Successful",
        //         //             order_id: 35249094,
        //         //             reference_no: "CANON-20230116053707-183",
        //         //             urls: ["https://gft.ph/sM4scAv1Zj"],
        //         //             credits_balance: "23150.00",
        //         //             credits_used: "100.00",
        //         //         },
        //         //         status: 0,
        //         //         merchant_name: "Giftaway",
        //         //         category: "Shop",
        //         //         image: "https://s3.amazonaws.com/images.giftaway.ph/o/bccca51c-2d40-4d88-ba9b-5e5899a07789.jpg",
        //         //         egift_status: "Redeemed",
        //         //         send_option: "both",
        //         //         egift_title: "P100",
        //         //         description: null,
        //         //         highlights: null,
        //         //         recommendations: null,
        //         //         terms: "###Print or copy the eGift code\r\nYou will need to present the code to the manager upon using it at our location.\r\n###Go to our participating location\r\nSee our location [here](http://canon-app-test.giftaway.ph/card/universalplus?catalog#locations)\r\n###Present code and enjoy!\r\nPresent the code to the manager for validation &ndash; enjoy your gift!",
        //         //         created_at: "2023-01-16 17:37:09",
        //         //         updated_at: "2023-01-17 17:58:24",
        //         //         ignore: {},
        //         //     },
        //         //     {
        //         //         id: 35,
        //         //         user_id: 183,
        //         //         merchant_id: 6312,
        //         //         denomination_id: 7043,
        //         //         quantity: null,
        //         //         price: 1000,
        //         //         customer_name: "Yves Tatad",
        //         //         order_id: 35249270,
        //         //         urls: '["https:\\/\\/gft.ph\\/mGWEseJQ5R"]',
        //         //         giftaway_json: {
        //         //             status_code: 100,
        //         //             status: "Successful",
        //         //             order_id: 35249270,
        //         //             reference_no: "CANON-20230116054929-183",
        //         //             urls: ["https://gft.ph/mGWEseJQ5R"],
        //         //             credits_balance: "22150.00",
        //         //             credits_used: "1000.00",
        //         //         },
        //         //         status: 0,
        //         //         merchant_name: "Giftaway",
        //         //         category: "Shop",
        //         //         image: "https://s3.amazonaws.com/images.giftaway.ph/o/3be21796-c433-405b-805c-04ade136a63b.jpg",
        //         //         egift_status: "Redeemed",
        //         //         send_option: "both",
        //         //         egift_title: "P1,000",
        //         //         description: null,
        //         //         highlights: null,
        //         //         recommendations: null,
        //         //         terms: "###Print or copy the eGift code\r\nYou will need to present the code to the manager upon using it at our location.\r\n###Go to our participating location\r\nSee our location [here](http://canon-app-test.giftaway.ph/card/universalplus?catalog#locations)\r\n###Present code and enjoy!\r\nPresent the code to the manager for validation &ndash; enjoy your gift!",
        //         //         created_at: "2023-01-16 17:49:31",
        //         //         updated_at: "2023-01-19 16:16:14",
        //         //         ignore: {},
        //         //     },
        //         //     {
        //         //         id: 36,
        //         //         user_id: 197,
        //         //         merchant_id: 6961,
        //         //         denomination_id: 9812,
        //         //         quantity: null,
        //         //         price: 100,
        //         //         customer_name: "Lalisa Manoban",
        //         //         order_id: 35251710,
        //         //         urls: '["https:\\/\\/gft.ph\\/ext16Cr4El"]',
        //         //         giftaway_json: {
        //         //             status_code: 100,
        //         //             status: "Successful",
        //         //             order_id: 35251710,
        //         //             reference_no: "CANON-20230116081710-197",
        //         //             urls: ["https://gft.ph/ext16Cr4El"],
        //         //             credits_balance: "22050.00",
        //         //             credits_used: "100.00",
        //         //         },
        //         //         status: 0,
        //         //         merchant_name: "The SM Store",
        //         //         category: "Shop",
        //         //         image: "https://s3.amazonaws.com/images.giftaway.ph/o/3386d80e-5271-4b59-be53-a44d3f51d330.jpg",
        //         //         egift_status: "Redeemed",
        //         //         send_option: "both",
        //         //         egift_title: "P100",
        //         //         description:
        //         //             "The SM Store, the country’s leading department store chain was founded as a shoe store by Henry Sy, Sr., in October 1958 in downtown Manila. Mr. Sy, who is known as the visionary of Philippine retail because of his innovations in the industry, thought of establishing a chain of shoe stores with a store layout and merchandising concepts never before tried in the Philippines.\r\n\r\nThe success of the shoe store led to its expansion as a full line store, and the first SM Department Store opened in downtown Manila in 1972. With its exciting merchandise mix, world class interiors, one stop shopping convenience, and service, SM has become part of the lives of many Filipinos. Today, it has 64 branches strategically located around Metro Manila and key cities around the country, as well as in China and has rebranded as The SM Store.\r\n\r\nToday, it continues to take the lead in store innovations as it expands in both urban and rural communities, bringing world class shopping through its new and newly renovated stores around the Philippines. Each store is laid out to deliver convenience, value and variety to its shoppers.\r\n\r\nCombining great design and great retail, this is SM’s response to the growing demand for more affordable but fashionable environments, as well as the company’s efforts to serve more shoppers.  Design concepts, a global/local fusion of merchandise, premier service and innovative marketing programs come together to bring that shopping excitement.\r\n\r\nThe SM Store’s services go beyond shopping. Shoppers can pay their bills, exchange foreign currency, gift wrapping services and enjoy the convenience of a Gift Registry in the store, all in one stop. Value-added services such as ATM Banking, ticketing, remittance and a shopper loyalty program are also made available.\r\n\r\nIn response to the times, The SM Store now has SM Call to Deliver, and an online store ShopSM, and of course, the physical store – to better serve its customers and give them an omnichannel experience. This guarantees an exciting array of merchandise, secure payments, nationwide deliveries, and customer satisfaction with every transaction for a hassle-free shopping experience.",
        //         //         highlights: null,
        //         //         recommendations:
        //         //             "### Inside The SM Store:\r\n* Shoes\r\n* Bags\r\n* Accessories\r\n* Kids\r\n* Toys\r\n* Babies\r\n* Wears",
        //         //         terms: "### Go to the Bills Payment Counter of The SM Store or call #14376 for SM Call to Deliver\r\n[See the participating locations here](https://giftaway.ph/card/thesmstore?viewonly&catalog#locations). \r\n\r\n### For in-store redemption at The SM Store\r\nPresent your eGift at the Bills Payment Counter for validation. The cashier/officer will exchange it to SM Gift Pass that can be used at The SM Store.\r\n\r\n\r\n### For delivery through the SM Call to Deliver #14376\r\nCall #14376 and inform the Personal Shopper that you will be using an eGift. A Personal Shopper will reach out to verify and confirm the orders. Exclusive at The SM Store only. \r\n\r\n\r\n### Enjoy shopping!",
        //         //         created_at: "2023-01-16 20:17:12",
        //         //         updated_at: "2023-01-16 22:12:43",
        //         //         ignore: {},
        //         //     },
        //         //     {
        //         //         id: 37,
        //         //         user_id: 183,
        //         //         merchant_id: 6461,
        //         //         denomination_id: 7741,
        //         //         quantity: null,
        //         //         price: 100,
        //         //         customer_name: "Yves Tatad",
        //         //         order_id: 35252175,
        //         //         urls: '["https:\\/\\/gft.ph\\/PL4GHF0l2S"]',
        //         //         giftaway_json: {
        //         //             status_code: 100,
        //         //             status: "Successful",
        //         //             order_id: 35252175,
        //         //             reference_no: "CANON-20230116083517-183",
        //         //             urls: ["https://gft.ph/PL4GHF0l2S"],
        //         //             credits_balance: "21950.00",
        //         //             credits_used: "100.00",
        //         //         },
        //         //         status: 0,
        //         //         merchant_name: "7-Eleven CLiQQ",
        //         //         category: "Shop",
        //         //         image: "https://s3.amazonaws.com/images.giftaway.ph/o/e695cb63-a45b-4e98-9b1f-9df98a574020.jpg",
        //         //         egift_status: "Redeemed",
        //         //         send_option: "email",
        //         //         egift_title: "P100",
        //         //         description: null,
        //         //         highlights: null,
        //         //         recommendations: null,
        //         //         terms: "### Redeem your 7-Eleven CLiQQ Wallet\r\nGo to the [online redemption page](https://giftaway.ph/cliqq/redeem).\r\n\r\n### Open 7-Eleven CLiQQ mobile app\r\nThe eGift will be credited to your wallet account. To check, go to Manage Transactions and choose CLiQQ Pay under Transaction History.\r\n\r\n### Shop and use the app to pay \r\nFor use to purchase physical merchandise at any 7-Eleven store in the Philippines and at [CLiQQGrocery.com](https://cliqqgrocery.com/).",
        //         //         created_at: "2023-01-16 20:35:26",
        //         //         updated_at: "2023-01-19 16:18:43",
        //         //         ignore: {},
        //         //     },
        //         //     {
        //         //         id: 38,
        //         //         user_id: 183,
        //         //         merchant_id: 6300,
        //         //         denomination_id: 7031,
        //         //         quantity: null,
        //         //         price: 100,
        //         //         customer_name: "Yves Tatad",
        //         //         order_id: 35252219,
        //         //         urls: '["https:\\/\\/gft.ph\\/5xgG1wTXfR"]',
        //         //         giftaway_json: {
        //         //             status_code: 100,
        //         //             status: "Successful",
        //         //             order_id: 35252219,
        //         //             reference_no: "CANON-20230116084118-183",
        //         //             urls: ["https://gft.ph/5xgG1wTXfR"],
        //         //             credits_balance: "21850.00",
        //         //             credits_used: "100.00",
        //         //         },
        //         //         status: 0,
        //         //         merchant_name: "FamilyMart",
        //         //         category: "Shop",
        //         //         image: "https://s3.amazonaws.com/images.giftaway.ph/o/c612c320-c5c7-496e-a624-9d82b6a7457a.jpg",
        //         //         egift_status: "Redeemed",
        //         //         send_option: "both",
        //         //         egift_title: "P100",
        //         //         description:
        //         //             "With its wide variety of food and drinks condensed in a well-thought of space, combined with its strategic locations around the city, it’s no wonder that Family Mart quickly became a household name. Today, it joins the ranks of popular convenient stores in the country, and that’s hardly a surprise. Offering delightful assortment of food items that include makis, pastries, rice meals, and pastas, there’s bound to be something for everyone, at any hour of the day. Whether you want a cold beverage to quench your thirst after a run, you feel like having an impulsive ice cream, or you’re craving for a midnight snack, Family Mart is sure to deliver.",
        //         //         highlights:
        //         //             "Take note:\r\n\r\n* Searching for the nearest branch of Family Mart? They have a store locator. \r\n* The store regularly releases new products, so watch out for them.",
        //         //         recommendations:
        //         //             "###For your next visit:\r\n\r\n* Triangle Sandwiches \r\n* Chicken Karaage \r\n* Double Choco Loaf",
        //         //         terms: "###Print or copy the eGift code\r\nYou will need to present the code to the manager upon using it at our location.\r\n###Go to any of our 67 participating locations\r\nSee our locations [here](http://canon-app-test.giftaway.ph/card/familymart?catalog#locations)\r\n###Present code and enjoy!\r\nPresent the code to the manager for validation &ndash; enjoy your gift!",
        //         //         created_at: "2023-01-16 20:41:20",
        //         //         updated_at: "2023-01-19 18:16:06",
        //         //         ignore: {},
        //         //     },
        //         //     {
        //         //         id: 39,
        //         //         user_id: 183,
        //         //         merchant_id: 5164,
        //         //         denomination_id: 6866,
        //         //         quantity: null,
        //         //         price: 100,
        //         //         customer_name: "Yves Tatad",
        //         //         order_id: 35252228,
        //         //         urls: '["https:\\/\\/gft.ph\\/xAqPFHyasL"]',
        //         //         giftaway_json: {
        //         //             status_code: 100,
        //         //             status: "Successful",
        //         //             order_id: 35252228,
        //         //             reference_no: "CANON-20230116084213-183",
        //         //             urls: ["https://gft.ph/xAqPFHyasL"],
        //         //             credits_balance: "21750.00",
        //         //             credits_used: "100.00",
        //         //         },
        //         //         status: 0,
        //         //         merchant_name: "Globe Prepaid",
        //         //         category: "Service",
        //         //         image: "https://s3.amazonaws.com/images.giftaway.ph/o/6e5ef098-c7b1-471c-aaf5-5afc0f960daf.jpg",
        //         //         egift_status: "Redeemed",
        //         //         send_option: "email",
        //         //         egift_title: "Globe P100 Prepaid Load",
        //         //         description:
        //         //             "Globe Telecom, Inc. is the number one mobile brand in the Philippines and the purveyor of the Filipino digital lifestyle. We provide cellular, broadband and mobile data services by focusing on enriching our content offerings amid customers' growing preference for multimedia platforms across multiple screens and devices.\r\n\r\nWe believe companies that provide the best customer experience win. This is the overarching strategy of Globe.",
        //         //         highlights: null,
        //         //         recommendations: null,
        //         //         terms: "### Redeem your load through online form\r\n\r\nEnter your eGift code and mobile no. at [https://giftaway.ph/globeprepaid/redeem](https://giftaway.ph/globeprepaid/redeem)\r\n\r\n### Done!",
        //         //         created_at: "2023-01-16 20:42:14",
        //         //         updated_at: "2023-01-19 18:17:27",
        //         //         ignore: {},
        //         //     },
        //         //     {
        //         //         id: 40,
        //         //         user_id: 183,
        //         //         merchant_id: 5163,
        //         //         denomination_id: 8282,
        //         //         quantity: null,
        //         //         price: 100,
        //         //         customer_name: "Yves Tatad",
        //         //         order_id: 35252320,
        //         //         urls: '["https:\\/\\/gft.ph\\/FfQ4EMG5Q9"]',
        //         //         giftaway_json: {
        //         //             status_code: 100,
        //         //             status: "Successful",
        //         //             order_id: 35252320,
        //         //             reference_no: "CANON-20230116085235-183",
        //         //             urls: ["https://gft.ph/FfQ4EMG5Q9"],
        //         //             credits_balance: "21650.00",
        //         //             credits_used: "100.00",
        //         //         },
        //         //         status: 0,
        //         //         merchant_name: "Ayala Malls Cinemas",
        //         //         category: "Entertainment",
        //         //         image: "https://s3.amazonaws.com/images.giftaway.ph/o/58a2ab79-3816-47c5-8f92-7f7eabdade64.jpg",
        //         //         egift_status: "Redeemed",
        //         //         send_option: "both",
        //         //         egift_title: "P100",
        //         //         description:
        //         //             "Catch a film with loved ones at Ayala Malls Cinemas!\r\n\r\nBoasting of better images and surround sound features, Ayala Malls Cinemas lets patrons experience movies in a remarkable fashion. The exciting cinema concepts and game-changing technology… our movie cineastes will fall in love again and again with the experience of watching movies at the big screen.\r\n\r\nWho would not enjoy more thrills while watching the movie in the 4DX theater with magical motion seats  and auditorium filled with environmental effects as it will fully immerse you in each scene and lets you experience in the movie? Or get hooked with fully motorized leather recliner seats for luxury and full comfort in our A-Luxe Seats? Or experience BIG in one of the largest screen in the country? Regular screenings are available in 2D and 3D films.\r\n\r\nNow with all these exciting cinema advancements, there’s more reason to head out to Ayala Malls Cinemas and book the next blockbuster movie.\r\n\r\nSee it in the big screen, see it in Ayala Malls Cinemas!",
        //         //         highlights:
        //         //             "###Highlights \r\n\r\n* 4DX\r\n* A-Luxe Seats\r\n* A-Giant Screen\r\n* Dolby Atmos",
        //         //         recommendations:
        //         //             "###Recommendations\r\n\r\n* Local and Foreign films\r\n* 3D and 4DX films\r\n* Met Opera in HD (seasonal)\r\n* Festivals (seasonal)",
        //         //         terms: "###Print or copy the eGift code\r\nYou will need to present the code to the manager upon using it at our location.\r\n###Go to any of our 26 participating locations\r\nSee our locations [here](http://canon-app-test.giftaway.ph/card/ayalamallscinemas?catalog#locations)\r\n###Present code and enjoy!\r\nPresent the code to the manager for validation &ndash; enjoy your gift!",
        //         //         created_at: "2023-01-16 20:52:36",
        //         //         updated_at: "2023-01-19 19:54:48",
        //         //         ignore: {},
        //         //     },
        //         //     {
        //         //         id: 41,
        //         //         user_id: 183,
        //         //         merchant_id: 7066,
        //         //         denomination_id: 10430,
        //         //         quantity: null,
        //         //         price: 100,
        //         //         customer_name: "Yves Tatad",
        //         //         order_id: 35252333,
        //         //         urls: '["https:\\/\\/gft.ph\\/4wl8qb7MRP"]',
        //         //         giftaway_json: {
        //         //             status_code: 100,
        //         //             status: "Successful",
        //         //             order_id: 35252333,
        //         //             reference_no: "CANON-20230116085423-183",
        //         //             urls: ["https://gft.ph/4wl8qb7MRP"],
        //         //             credits_balance: "21550.00",
        //         //             credits_used: "100.00",
        //         //         },
        //         //         status: 0,
        //         //         merchant_name: "Shopwise",
        //         //         category: "Shop",
        //         //         image: "https://s3.amazonaws.com/images.giftaway.ph/o/a3450fa1-4e7f-44f8-8061-76b486f4edaf.jpg",
        //         //         egift_status: "Redeemed",
        //         //         send_option: "email",
        //         //         egift_title: "P100",
        //         //         description:
        //         //             "Maximize your budget with exclusive deals and promo bundles in Shopwise. Along with your usual buys, you can also indulge in their wide assortment of imported goods--from essentials, condiments, snacks, and beverages.",
        //         //         highlights: null,
        //         //         recommendations: null,
        //         //         terms: "###Open the Shopwise gift voucher barcode\r\nClick the USE THIS or SHOW CODE button to see the barcode. \r\n\r\n###Show the barcode to the cashier\r\nThe barcode will be scanned by the cashier during payment. The gift voucher balance will be used as full/partial payment for your purchase.\r\n\r\n_Note: Turn off the dark/night mode of the device._\r\n\r\n###Enjoy shopping!",
        //         //         created_at: "2023-01-16 20:54:24",
        //         //         updated_at: "2023-01-19 19:45:54",
        //         //         ignore: {},
        //         //     },
        //         //     {
        //         //         id: 42,
        //         //         user_id: 183,
        //         //         merchant_id: 6314,
        //         //         denomination_id: 9646,
        //         //         quantity: null,
        //         //         price: 100,
        //         //         customer_name: "Yves Tatad",
        //         //         order_id: 35252370,
        //         //         urls: '["https:\\/\\/gft.ph\\/4NhD0AQCTK"]',
        //         //         giftaway_json: {
        //         //             status_code: 100,
        //         //             status: "Successful",
        //         //             order_id: 35252370,
        //         //             reference_no: "CANON-20230116085859-183",
        //         //             urls: ["https://gft.ph/4NhD0AQCTK"],
        //         //             credits_balance: "21450.00",
        //         //             credits_used: "100.00",
        //         //         },
        //         //         status: 0,
        //         //         merchant_name: "Lazada",
        //         //         category: "Shop",
        //         //         image: "https://s3.amazonaws.com/images.giftaway.ph/o/3cc41541-5e40-4bc5-ade8-cf3780c92134.jpg",
        //         //         egift_status: "Redeemed",
        //         //         send_option: "email",
        //         //         egift_title: "P100",
        //         //         description:
        //         //             "With just about everything going mobile right now, it definitely stands to reason that shopping is one of the most popular activities to do on your laptop or phone. And why not? Doing your transactions while lounging in your couch at home definitely beats trying to brave the traffic on any given day. That’s what Lazada is known for. It’s a notable online shopping portal that lets you find most things you need, all with a few clicks. So whether you want to buy clothes, stock up on your baby’s toys, scout for new gadgets, or upgrade your home entertainment system, you can be sure you’ll find it all at Lazada.",
        //         //         highlights: null,
        //         //         recommendations:
        //         //             "###Shopping made easy:\r\n\r\n* Get the app and have Lazada on the go. \r\n* Create an account so you can track your orders.",
        //         //         terms: "###Redeem your Lazada voucher online\r\nGo to the [online redemption page](/lazada/redeem).\r\n\r\n###Wait for your voucher\r\nYou will normally get the voucher right after filling out the form.\r\n\r\n###Shop at [Lazada](http://www.lazada.com.ph/)\r\nUse your Lazada voucher as coupon/promo code upon checkout.",
        //         //         created_at: "2023-01-16 20:59:00",
        //         //         updated_at: "2023-01-19 18:44:45",
        //         //         ignore: {},
        //         //     },
        //         //     {
        //         //         id: 43,
        //         //         user_id: 183,
        //         //         merchant_id: 7043,
        //         //         denomination_id: 10305,
        //         //         quantity: null,
        //         //         price: 100,
        //         //         customer_name: "Yves Tatad",
        //         //         order_id: 35252647,
        //         //         urls: '["https:\\/\\/gft.ph\\/dpeeaK3Mjn"]',
        //         //         giftaway_json: {
        //         //             status_code: 100,
        //         //             status: "Successful",
        //         //             order_id: 35252647,
        //         //             reference_no: "CANON-20230116093331-183",
        //         //             urls: ["https://gft.ph/dpeeaK3Mjn"],
        //         //             credits_balance: "20950.00",
        //         //             credits_used: "100.00",
        //         //         },
        //         //         status: 0,
        //         //         merchant_name: "Razer Gold",
        //         //         category: "Service",
        //         //         image: "https://s3.amazonaws.com/images.giftaway.ph/o/632d67d4-f2c9-4773-b9d8-442cfb23d5c9.jpg",
        //         //         egift_status: "Redeemed",
        //         //         send_option: "sms",
        //         //         egift_title: "P100",
        //         //         description:
        //         //             "Razer Gold is the only virtual credit that is neutral across all games and gets you more bang for your buck.",
        //         //         highlights: null,
        //         //         recommendations: null,
        //         //         terms: "### Redeem Razer Gold Wallet Code online\r\n\r\nEnter your eGift code and mobile no. at [https://giftaway.ph/razergold/redemption](https://giftaway.ph/razergold/redemption).\r\n\r\n### Top-up your Razer Gold Account\r\n\r\nYou will receive the Razer Gold Wallet Code via email/SMS and use it to top-up your Razer Gold Wallet [here](https://gold.razer.com/).\r\n\r\n### Done!",
        //         //         created_at: "2023-01-16 21:33:33",
        //         //         updated_at: "2023-01-19 19:56:18",
        //         //         ignore: {},
        //         //     },
        //         // ],
        //         meta: {
        //             total: 61,
        //         },
        //     },
        // });
    },
    // updatePromo(id=null, ...payload) {
    //   return axiosV1.post(`promos/update/${id}`, ...payload)
    // },
    // deletePromo(id=null) {
    //   return axiosV1.delete(`promos/delete/${id}`)
    // },
    // deletePromos(ids=null) {
    //   return axiosV1.post(`promos/bulk/delete`, ids)
    // },
    // destroyPromo(id=null) {
    //   return axiosV1.delete(`promos/destroy/${id}`)
    // },
    // destroyPromos(ids=null) {
    //   return axiosV1.post(`promos/bulk/destroy`, ids)
    // },
    // recoverPromo(id=null) {
    //   return axiosV1.post(`promos/recover/${id}`)
    // },
    // recoverPromos(ids=null) {
    //   return axiosV1.post(`promos/bulk/recover`, ids)
    // },
    // importPromo(file=null) {
    //   let formData = new FormData();
    //   formData.append('file', file);
    //   axiosV1.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    //   return axiosV1.post(`promos/import`, formData)
    // },
};
